module.exports = __webpack_public_path__ + "img/glass-orange-coctail-1-1600x800.a33949f8.jpg";